import React from 'react';
import ToggleField from 'material-ui/Toggle';
import { grey500 } from 'material-ui/styles/colors';

const Toogle = ({ input, label, meta = {}, style, containerStyle, helperText, ...custom }) => {
  const { touched, error } = meta;
  const value = input ? input.value : custom.value;
  const onToggle = input ? input.onChange : custom.onChange;
  return (
    <div style={containerStyle}>
      <ToggleField
        label={label}
        labelStyle={{ fontWeight: 400 }}
        errorText={touched && error}
        toggled={value ? true : false}
        onToggle={onToggle}
        style={{
          fontSize: '0.875em',
          ...style
        }}
        {...input}
        {...custom}
      />
      {helperText && (
        <p
          style={{
            color: grey500,
            fontSize: '12px',
            lineHeight: '16px',
            margin: '-1px 44px 0 0'
          }}
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Toogle;



// WEBPACK FOOTER //
// ./src/components/basic/Toggle.js